makeFieldFunctionOptions